module.exports = __webpack_public_path__ + "img/IMG_2254_FoamcoreMatted.47d2ea97.jpg";